import useTranslation from 'next-translate/useTranslation';

// Hooks
import useLogout from '@/utils/hooks/user/useLogout';

// Components
import Icon from '@/components/base/Icon';

export function SettingsLogout() {
    const { t } = useTranslation('commons');
    const { logout } = useLogout();

    return (
        <button
            className="flex w-full flex-row items-center space-x-2 rounded-md p-2 font-GSemiBold text-xs text-icoGray-500 hover:text-icoBlue dark:text-icoDarkMode-wolf"
            onClick={logout}>
            <Icon icon={'logout'} />
            <span>{t('logout')}</span>
        </button>
    );
}
